<div class="row mt-1">
  <h3>Datos de facturación</h3>
  <p>¿Desea facturar con la siguiente información?</p>
  <div class="row" *ngIf="router.url.includes('/clients/cart') && !router.url.includes('/clients/cart/retail')">
    <div class="col">
      <h6>
        Si requieres agregar nuevos datos de facturación o seleccionar una dirección distinta como favorita
        <a (click)="navegarAPantallaB()" id="redlebel" role="button">Ingresa Aquí.</a>
      </h6>
    </div>
  </div>

  <div class="col w-100 mt-1">
    <mat-radio-group name="baOptions" [(ngModel)]="selectedBAOption">
      <div class="row">
        <div class="col-md-1">
          <mat-radio-button *ngIf="databilling != null" name="baOptions" [value]="'actual'" (change)="validShowDatafact(false)"></mat-radio-button>
        </div>
        <div class="col-md-7" *ngIf="databilling != null">
          <div class="row">
            <div class="col-md-10 w-100">
              <p color="gray" class="p-dsdt">Razón social o nombre</p>
              <p class="p-dsdv">{{ databilling.businessName }}</p>
            </div>
            <div class="col-md-10 w-100">
              <p color="gray" class="p-dsdt">RFC</p>
              <p class="p-dsdv">{{ databilling.rfc }}</p>
            </div>
            <div class="col-md-10 w-100">
              <p color="gray" class="p-dsdt pfisica"></p>
              <p class="p-dsdv">{{ databilling.typePerson }}</p>
            </div>
            <div class="col-md-10 w-100">
              <p color="gray" class="p-dsdt">Régimen fiscal</p>
              <p class="p-dsdv">{{ databilling.regimen }}</p>
            </div>
            <div class="col-md-10 w-100">
              <p color="gray" class="p-dsdt">Uso de CFDI</p>
              <p class="p-dsdv">{{ databilling.cfdi }}</p>
            </div>
            <div class="col-md-10 w-100">
              <p color="gray" class="p-dsdt">Código postal</p>
              <p class="p-dsdv">{{ databilling.zipCode }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="!router.url.includes('/clients/cart') || router.url.includes('/clients/cart/retail')">
        <div class="col">
          <mat-radio-button name="baOptions" [value]="'other'" (change)="validShowDatafact(true)"> Ingresa datos de facturación distintos </mat-radio-button>
        </div>
      </div>
    </mat-radio-group>

    <dhl-form-data-billing-fields
      [typePersonList]="userCatalogs.data.catTypePerson"
      [catCFDIList]="userCatalogs.data.catCFDI"
      [taxRegimeList]="userCatalogs.data.taxRegime"
      *ngIf="showDatafacturingAdd"
      #formDataBillingFields></dhl-form-data-billing-fields>
  </div>
</div>
